export default __webpack_public_path__ + "static/media/boleto-completo-example.c81fb016.png";